import { render, staticRenderFns } from "./MetodicTable.vue?vue&type=template&id=55d9b040&scoped=true&"
import script from "./MetodicTable.vue?vue&type=script&lang=js&"
export * from "./MetodicTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d9b040",
  null
  
)

export default component.exports